import { CurrencyType } from '@wolffun/system-currency';
import dayjs from 'dayjs';
import { ceil, parseInt } from 'lodash';
import { AppError } from '@vestingSafe/src/redux/types';
export const parseAmountGTHGToSystemCurrency = gTHGAmount => {
  return {
    token: CurrencyType.GTHG,
    value: gTHGAmount > 0 ? gTHGAmount.toString() : '0'
  };
};
export const countDownToUTC00 = () => {
  const tomorrow = new Date();
  tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
  tomorrow.setUTCHours(0, 0, 0, 0);
  return dayjs.duration(dayjs.utc(tomorrow).diff(dayjs.utc()));
};
export const getFeeAmount = (claimAmount, claimFee, minPaid) => {
  if (claimAmount && claimFee && minPaid) {
    return ceil(parseInt(claimAmount.value) * (claimFee / 100));
  }

  return 0;
};
export const getClaimableAmount = (claimAmount, feeAmount, minPaid) => {
  if (claimAmount && feeAmount && minPaid) {
    if (parseInt(claimAmount.value) < parseInt(minPaid.value)) {
      return parseInt(minPaid.value) - feeAmount;
    }

    return parseInt(claimAmount.value) - feeAmount;
  }

  return 0;
};
export const formatErrorMessage = error => {
  if (!error) return '';

  switch (error) {
    case AppError.UNNKOWN:
      return 'Something went wrong, please try again';

    case AppError.MAX_GTHG_VESTING_SAFE_CLAIMED:
      return 'You have already received all THG today, please try again the next day';

    default:
      return `Error code ${error}`;
  }
};